(() => {
  /**
   * Uses Swiper package to create a carousel
   * More info: https://swiperjs.com/
   */
  if (customElements.get('cart-upsells')) {
    return;
  }

  class CartUpsells extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        slidesPerView: 1,
        spaceBetween: 10,
      };
    }

    /**
     * Init slider.
     *
     * @returns {Void}
     */
    initSlider() {
      this.slider = new Swiper(this.sliderElement, this.options);
    }

    /**
     * Connected callback.
     *
     * @returns {Void}
     */
    connectedCallback() {
      this.sliderElement = this.querySelector('[data-slider]');
      if (!this.sliderElement) return;
      this.initSlider();
    }
  }

  customElements.define('cart-upsells', CartUpsells);
})();
